import request from "../../util/request";
import { API_URL, APP_KEY ,HTTP_URL} from "../../util/constants";

export function loginRequest(username,pwd, callback) {
    // let formData = new FormData();
    // formData.append('user_login', username);
    // formData.append('pwd', pwd);
    // // formData.append('token', token);
    // formData.append('web_code', "1");
    return request("/ygbh/login", {
        method: "POST",
        body: {
            "user_login":username,
            "pwd":pwd
        }
    }, callback);
}

//新登录接口
// export function loginRequest(phone,pwd,callback) {
//   let formData = new FormData();
//   formData.append("appkey",APP_KEY);
//   formData.append("caozuo",'login');
//   formData.append("phone", phone);
//   formData.append("pwd", pwd);
//
//   return fetch(HTTP_URL+'index.php/User/i',{
//     method: 'post',
//     body: formData,
//   }).then(function (res) {
//     return res.json();
//   }).then(function (json) {
//     callback && callback(json);
//   }).catch(e => {
//     console.error(e);
//     callback && callback(e);
//
//   });
// }
